import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const ApprovalTimeChart = ({ data, stats }) => {
  // Debug: Log what the component receives
  console.log("ApprovalTimeChart received:", { data, stats });

  if (!data || data.length === 0) {
    console.log("ApprovalTimeChart: No data received");
    return (
      <div className="w-full h-full">
        <div className="chart-header">
          <h3 className="chart-title">Tiempo de Aprobación</h3>
          <p className="chart-subtitle">Promedio días</p>
        </div>
        <div className="chart-content">
          <div className="flex items-center justify-center h-64 text-gray-500">
            <div className="text-center">
              <div className="text-4xl mb-2">⏱️</div>
              <p>No hay datos de tiempo de aprobación</p>
            </div>
          </div>
        </div>
        <div className="chart-footer">
          <div className="chart-insight">Agilidad del proceso</div>
          <div className="chart-metric">Sin datos</div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full">
      <div className="chart-header">
        <h3 className="chart-title">Tiempo de Aprobación</h3>
        <p className="chart-subtitle">Distribución por rangos de tiempo</p>
      </div>
      <div className="chart-content" style={{ height: "300px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="range"
              angle={-45}
              textAnchor="end"
              height={80}
              interval={0}
            />
            <YAxis />
            <Tooltip
              content={({ active, payload, label }) => {
                if (active && payload && payload.length) {
                  const data = payload[0].payload;
                  return (
                    <div className="bg-white dark:bg-slate-800 p-3 border border-slate-200 dark:border-slate-700 rounded-lg shadow-lg">
                      <p className="font-semibold">{data.range}</p>
                      <p className="text-sm text-slate-600 dark:text-slate-400">
                        Cantidad: {data.count}
                      </p>
                      <p className="text-sm text-slate-600 dark:text-slate-400">
                        Porcentaje: {data.percentage}%
                      </p>
                    </div>
                  );
                }
                return null;
              }}
            />
            <Legend />
            <Bar
              dataKey="count"
              name="Cantidad de IPRs"
              fill="#3b82f6"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="chart-footer">
        <div className="chart-insight">
          {stats?.averageDays >= 0
            ? `${stats.averageDays} días promedio`
            : "Sin datos suficientes"}
        </div>
        <div className="chart-metric">
          {stats?.totalApproved || 0} IPRs aprobados
        </div>
      </div>
    </div>
  );
};

export default ApprovalTimeChart; 